import type {RouteMap} from '@gl/app/lit/types/routes.js';

export const routes: RouteMap = {
  all: {
    paths: ['*'],
    components: {
      interface: () =>
        import(
          /* webpackChunkName: "interface" */
          './interface.js'
        ),
      global: () =>
        import(
          /* webpackChunkName: "global" */
          './global.js'
        ),
    },
  },
  audiences: {
    paths: ['/audiences'],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "audiences" */
          './audiences.js'
        ),
    },
  },
  audienceBuilder: {
    paths: [
      '/v2/dataset_groups/:dataset_group_id/audiences/new',
      '/v2/dataset_groups/:dataset_group_id/audiences/:id/edit',
    ],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "audience_builder_v2" */
          './audience_builder.js'
        ),
    },
  },
  audienceShow: {
    paths: ['/v2/dataset_groups/:dataset_group_id/audiences/:id'],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "audience_show_v2" */
          './audience_show.js'
        ),
    },
  },
  schemaBuilder: {
    paths: ['/dataset_groups/:dataset_group_id/edit', '/dataset_groups/new'],
    components: {
      schemaBuilderComponents: () =>
        import(
          /* webpackChunkName: "data_manager" */
          './data_manager.js'
        ),
    },
  },
  designSystem: {
    paths: ['/internal/design_system'],
    components: {
      designSystemComponent: () =>
        import(
          /* webpackChunkName: "internal_ds" */
          './design_system.js'
        ),
    },
  },
  journeyDryRun: {
    paths: [
      '/v2/journeys/:id/dry_run',
      '/v2/dataset_groups/:dataset_group_id/journeys/:id/dry_run',
    ],
    components: {
      journeyDryRunComponents: () =>
        import(
          /* webpackChunkName: "journey_builder_v2" */
          './journey_dry_run.js'
        ),
    },
  },
  journeyBuilder: {
    paths: [
      '/v2/journeys/new',
      '/v2/journeys/:id',
      '/v2/journeys/:id/edit',
      '/v2/dataset_groups/:dataset_group_id/journeys/:id',
      '/v2/dataset_groups/:dataset_group_id/journeys/:id/edit',
    ],
    components: {
      audiencesComponents: () =>
        import(
          /* webpackChunkName: "journey_builder_v2" */
          './journey_builder.js'
        ),
    },
  },
  onboarding: {
    paths: ['/onboarding'],
    components: {
      onboardingComponents: () =>
        import(
          /* webpackChunkName: "onboarding" */
          './onboarding.js'
        ),
    },
  },
  adminOrganizations: {
    paths: ['/admin/organizations/:id/edit'],
    components: {
      adminOrganizationsComponents: () =>
        import(
          /* webpackChunkName: "admin_organizations" */
          './admin_organizations.js'
        ),
    },
  },
  teams: {
    paths: ['/teams/:id/edit'],
    components: {
      teamsComponents: () =>
        import(
          /* webpackChunkName: "admin_teams" */
          './teams.js'
        ),
    },
  },
  home: {
    paths: ['/home'],
    components: {
      home: () =>
        import(
          /* webpackChunkName: "home" */
          './home.js'
        ),
    },
  },
  organization: {
    paths: ['/organization'],
    components: {
      organizationComponents: () =>
        import(
          /* webpackChunkName: "organization" */
          './organization.js'
        ),
    },
  },
  embed: {
    paths: [
      '/embed/audiences/new',
      '/embed/audiences/:audience_id',
      '/embed/audiences/:audience_id/edit',
    ],
    components: {
      embedComponents: () => import('./embed.js'),
      // Cards and bulk export register in this bundle. Importing them from
      // embed.js again gives that CSS a second order and fails the build.
      audienceBuilderComponents: () =>
        import(
          /* webpackChunkName: "audience_builder_v2" */
          './audience_builder.js'
        ),
    },
  },
  sourceConnections: {
    paths: ['/datasets/new', '/datasets/:id/edit'],
    components: {
      datasetsComponents: () =>
        import(
          /* webpackChunkName: "datasets" */
          './datasets.js'
        ),
    },
  },
  signalRoutes: {
    paths: ['/signal_routes/:id'],
    components: {
      signalRoutesComponents: () =>
        import(
          /* webpackChunkName: "signal_routes" */
          './signal_routes.js'
        ),
    },
  },
};
